import * as _ from 'lodash';
import { IDonorExportability } from '@nkr/models/index';
import { GridWrapper } from './styles';
import { AgGridReact } from 'ag-grid-react';
import { AgGridEvent } from 'ag-grid-community';
import { IHeaderParams, GridReadyEvent, ValueGetterParams, FirstDataRenderedEvent, ICellRendererParams, ColDef } from 'ag-grid-community';
import SortableHeaderComponent from '@nkr/views/admin/center/list/common/sortable-header';
import { Glyphicon } from 'react-bootstrap';
import { useMemo } from 'react';
import { Utility } from '@nkr/services/utility';

interface IProps {
    report: IDonorExportability[],
    onGridReady: (e: GridReadyEvent) => void
}

const DonorExportabilityReportGrid = (props: IProps) => {
    const onGridReady = (e: GridReadyEvent) => {
        props.onGridReady(e);
        // e.api.sizeColumnsToFit();
    };

    const onSortChanged = (e: AgGridEvent) => {
        e.api.refreshCells();
    };

    const onFirstDataRendered = (e: FirstDataRenderedEvent) => {
        // e.api.sizeColumnsToFit();
    };

    const reportColumns: ColDef[] = [
        {
            colId: 'Rank',
            field: 'rank',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    R#
                </SortableHeaderComponent>,
            headerName: 'Rank',
            width: 55,
            resizable: true,
            suppressSizeToFit: true,
            sortable: false,
            valueGetter: (props: ValueGetterParams) => props.node.rowIndex + 1
        },
        {
            colId: 'donorCenterAlias',
            field: 'donorCenterAlias',
            headerName: 'Center',
            comparator: Utility.nameComparator,
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    Center
                </SortableHeaderComponent>,
            cellRendererFramework: (props: ICellRendererParams) => {
                let data = props.data as IDonorExportability;
                let { donorCenterId, donorCenterAlias } = data;

                if (donorCenterId > 0) {
                    return (
                        <a target={'_blank'} href={"/center/" + donorCenterId + "/profile/edit"}>{donorCenterAlias}</a>
                    );
                } else {
                    return (
                        <span>{donorCenterAlias}</span>
                    );
                }
            },
            width: 80,
        },
        {
            colId: 'donorAlias',
            field: 'donorAlias',
            headerName: 'Donor Alias',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    Donor <br />Alias
                </SortableHeaderComponent>,
            cellRendererFramework: (props: ICellRendererParams) => {
                let data = props.data as IDonorExportability;
                let { donorAlias, id: donorId, donorCenterId } = data;

                if (donorId > 0 && donorCenterId > 0) {
                    return (
                        <a target={'_blank'} href={"/center/" + donorCenterId + "/donor/" + donorId + "/profile"}>{donorAlias}</a>
                    )
                } else {
                    return (
                        <span>{donorAlias}</span>
                    );
                }
            },
            width: 120,
        },
        {
            colId: 'donorType',
            field: 'donorType',
            headerName: 'Donor Type',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    Donor<br /> Type
                </SortableHeaderComponent>,
            width: 60,
        },
        {
            colId: 'abo',
            field: 'abo',
            headerName: 'ABO',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    ABO
                </SortableHeaderComponent>,
            width: 45,
        },
        {
            colId: 'swap',
            field: 'swap',
            headerName: 'swap',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    Swap
                </SortableHeaderComponent>,
            width: 80,
        },
        {
            colId: 'donorDonationStartDate',
            field: 'donorDonationStartDateDisplay',
            headerName: 'Donation Start Date',
            width: 90,
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    Donation<br /> Start Date
                </SortableHeaderComponent>,
        },
        {
            colId: 'donorDonationEndDate',
            field: 'donorDonationEndDateDisplay',
            headerName: 'Donation End Date',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    Donation<br /> End Date
                </SortableHeaderComponent>,
            width: 90,
        },
        {
            colId: 'typingDate',
            field: 'typingDateDisplay',
            headerName: 'Typing Date',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    Typing<br />Date
                </SortableHeaderComponent>,
            width: 90,
        },
        {
            colId: 'hlaDate',
            field: 'hlaDateDisplay',
            headerName: 'Hla Date',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    HLA<br />Date
                </SortableHeaderComponent>,
            width: 90,
        },
        {
            colId: 'aboDate',
            field: 'aboDateDisplay',
            headerName: 'ABO Date',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    ABO<br />Date
                </SortableHeaderComponent>,
            width: 90,
        },
        {
            colId: 'medChartDate',
            field: 'medChartDateDisplay',
            headerName: 'Med Chart Date',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    Med<br />Chart<br /> Date
                </SortableHeaderComponent>,
            width: 90,
        },
        {
            colId: 'incompleteWeight',
            field: 'incompleteWeight',
            headerName: 'Incomplete Weight',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    Incomplete <br />Weight
                </SortableHeaderComponent>,
            width: 120,
        },
        {
            colId: 'isChainStarter',
            field: 'isChainStarter',
            headerName: 'Is Chain Starter',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    Is<br />Chain<br />Starter
                </SortableHeaderComponent>,
            width: 70,
            cellRendererFramework: (props: ICellRendererParams) => props.value ? <Glyphicon glyph='ok' /> : null
        },
        {
            colId: 'donorIsActive',
            field: 'donorIsActive',
            headerName: 'Donor Is Active',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    Is<br />Active
                </SortableHeaderComponent>,
            width: 70,
            cellRendererFramework: (props: ICellRendererParams) => props.value ? <Glyphicon glyph='ok' /> : null
        },
        {
            colId: 'donorIsExportable',
            field: 'donorIsExportable',
            headerName: 'Donor Is Exportable',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    Is<br />Exportable
                </SortableHeaderComponent>,
            width: 85,
            cellRendererFramework: (props: ICellRendererParams) => props.value ? <Glyphicon glyph='ok' /> : null
        },
        {
            colId: 'isRecipientComplete',
            field: 'isRecipientComplete',
            headerName: 'Is Recipient Complete',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    Is<br />Recipient <br />Complete
                </SortableHeaderComponent>,
            width: 90,
            cellRendererFramework: (props: ICellRendererParams) => props.value ? <Glyphicon glyph='ok' /> : null
        },
        {
            colId: 'hasValidDateOfBirth',
            field: 'hasValidDateOfBirth',
            headerName: 'Has Valid Date of Birth',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    Has<br />Valid<br />DoB
                </SortableHeaderComponent>,
            width: 70,
            cellRendererFramework: (props: ICellRendererParams) => props.value ? <Glyphicon glyph='ok' /> : null
        },
        {
            colId: 'hasAbo',
            field: 'hasAbo',
            headerName: 'Has Abo',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    Has<br />ABO
                </SortableHeaderComponent>,
            width: 70,
            cellRendererFramework: (props: ICellRendererParams) => props.value ? <Glyphicon glyph='ok' /> : null
        },
        {
            colId: 'isAboConfirmed',
            field: 'isAboConfirmed',
            headerName: 'Is Abo Confirmed',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    Is<br />ABO<br />Confirmed
                </SortableHeaderComponent>,
            width: 80,
            cellRendererFramework: (props: ICellRendererParams) => props.value ? <Glyphicon glyph='ok' /> : null
        },
        {
            colId: 'hasDonationStartDate',
            field: 'hasDonationStartDate',
            headerName: 'Has Donation Start Date',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    Has<br />Donation <br /> Start Date
                </SortableHeaderComponent>,
            width: 100,
            cellRendererFramework: (props: ICellRendererParams) => props.value ? <Glyphicon glyph='ok' /> : null
        },
        {
            colId: 'hasDonationEndDate',
            field: 'hasDonationEndDate',
            headerName: 'Has Donation End Date',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    Has<br />Donation <br />End Date
                </SortableHeaderComponent>,
            width: 100,
            cellRendererFramework: (props: ICellRendererParams) => props.value ? <Glyphicon glyph='ok' /> : null
        },
        {
            colId: 'isHlaComplete',
            field: 'isHlaComplete',
            headerName: 'isHlaComplete',
            width: 80,
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    Is<br />HLA<br />Complete
                </SortableHeaderComponent>,
            cellRendererFramework: (props: ICellRendererParams) => props.value ? <Glyphicon glyph='ok' /> : null
        },
        {
            colId: 'hlaConfirmation',
            field: 'hlaConfirmation',
            headerName: 'Hla Confirmation',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    HLA<br />Confirmation
                </SortableHeaderComponent>,
            width: 95,
            cellRendererFramework: (props: ICellRendererParams) => props.value ? <Glyphicon glyph='ok' /> : null
        },
        {
            colId: 'hasKidneySize',
            field: 'hasKidneySize',
            headerName: 'Has Kidney Size',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    Has<br />Kidney<br />Size
                </SortableHeaderComponent>,
            width: 80,
            cellRendererFramework: (props: ICellRendererParams) => props.value ? <Glyphicon glyph='ok' /> : null
        },
        {
            colId: 'hasCTScan',
            field: 'hasCTScan',
            headerName: 'Has CT Scan',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    Has<br />CT Scan
                </SortableHeaderComponent>,
            width: 80,
            cellRendererFramework: (props: ICellRendererParams) => props.value ? <Glyphicon glyph='ok' /> : null
        },
        {
            colId: 'hasTyping',
            field: 'hasTyping',
            headerName: 'Has Typing',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    Has<br />Typing
                </SortableHeaderComponent>,
            width: 90,
            cellRendererFramework: (props: ICellRendererParams) => props.value ? <Glyphicon glyph='ok' /> : null
        },
        {
            colId: 'hasMedChart',
            field: 'hasMedChart',
            headerName: 'Has Med Chart',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    Has<br />Med Chart
                </SortableHeaderComponent>,
            width: 90,
            cellRendererFramework: (props: ICellRendererParams) => props.value ? <Glyphicon glyph='ok' /> : null
        },
        {
            colId: 'hasAdpForm',
            field: 'hasAdpForm',
            headerName: 'Has Adp Form',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    Has<br />ADP Form
                </SortableHeaderComponent>,
            width: 80,
            cellRendererFramework: (props: ICellRendererParams) => props.value ? <Glyphicon glyph='ok' /> : null
        },
        {
            colId: 'hasCtReport',
            field: 'hasCtReport',
            headerName: 'Has CT Report',
            width: 80,
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    Has<br />CT Report
                </SortableHeaderComponent>,
            cellRendererFramework: (props: ICellRendererParams) => props.value ? <Glyphicon glyph='ok' /> : null
        },
        {
            colId: 'hasDonorTbStatus',
            field: 'hasDonorTbStatus',
            headerName: 'Has Donor Tb Status',
            width: 90,
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    Has Donor <br /> TB Status
                </SortableHeaderComponent>,
            cellRendererFramework: (props: ICellRendererParams) => props.value ? <Glyphicon glyph='ok' /> : null
        },
        {
            colId: 'hasWhichKidney',
            field: 'hasWhichKidney',
            headerName: 'Has Which Kidney',
            width: 70,
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    Has<br />Which<br />Kidney
                </SortableHeaderComponent>,
            cellRendererFramework: (props: ICellRendererParams) => props.value ? <Glyphicon glyph='ok' /> : null
        },
        {
            colId: 'hasNumberOfVeins',
            field: 'hasNumberOfVeins',
            headerName: 'Has Number Of Veins',
            width: 90,
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    Has<br />Number<br />of Veins
                </SortableHeaderComponent>,
            cellRendererFramework: (props: ICellRendererParams) => props.value ? <Glyphicon glyph='ok' /> : null
        },
        {
            colId: 'hasNumberOfArteries',
            field: 'hasNumberOfArteries',
            headerName: 'Has Number Of Arteries',
            width: 90,
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    Has<br />Number<br />of Arteries
                </SortableHeaderComponent>,
            cellRendererFramework: (props: ICellRendererParams) => props.value ? <Glyphicon glyph='ok' /> : null
        },
        {
            colId: 'hasNumberofUreters',
            field: 'hasNumberofUreters',
            headerName: 'Has Number of Ureters',
            width: 90,
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    Has<br />Number<br /> of Ureters
                </SortableHeaderComponent>,
            cellRendererFramework: (props: ICellRendererParams) => props.value ? <Glyphicon glyph='ok' /> : null
        },
        {
            colId: 'donorIsAdp',
            field: 'donorIsAdp',
            headerName: 'Donor Is Adp',
            width: 90,
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    Donor<br />Is ADP
                </SortableHeaderComponent>,
            cellRendererFramework: (props: ICellRendererParams) => props.value ? <Glyphicon glyph='ok' /> : null
        },
        {
            colId: 'donorIsWorkedUp',
            field: 'donorIsWorkedUp',
            headerName: 'Donor Is WorkedUp',
            width: 95,
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    Donor<br />Is Worked Up
                </SortableHeaderComponent>,
            cellRendererFramework: (props: ICellRendererParams) => props.value ? <Glyphicon glyph='ok' /> : null
        },
        {
            colId: 'hasAntiHcv',
            field: 'hasAntiHcv',
            headerName: 'Has Anti Hcv',
            width: 90,
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    Has<br />Anti HCV
                </SortableHeaderComponent>,
            cellRendererFramework: (props: ICellRendererParams) => props.value ? <Glyphicon glyph='ok' /> : null
        },
        {
            colId: 'hasDonorHiv',
            field: 'hasDonorHiv',
            headerName: 'Has Donor Hiv',
            width: 90,
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    Has<br />Donor HIV
                </SortableHeaderComponent>,
            cellRendererFramework: (props: ICellRendererParams) => props.value ? <Glyphicon glyph='ok' /> : null
        },
        {
            colId: 'hasDonorEBV',
            field: 'hasDonorEBV',
            headerName: 'Has Donor EBV',
            width: 90,
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    Has<br />Donor EBV
                </SortableHeaderComponent>,
            cellRendererFramework: (props: ICellRendererParams) => props.value ? <Glyphicon glyph='ok' /> : null
        },   
        {
            colId: 'hasDonorCMV',
            field: 'hasDonorCMV',
            headerName: 'Has Donor CMV',
            width: 90,
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    Has<br />Donor CMV
                </SortableHeaderComponent>,
            cellRendererFramework: (props: ICellRendererParams) => props.value ? <Glyphicon glyph='ok' /> : null
        },
        {
            colId: 'hasDonorHepbAntibody',
            field: 'hasDonorHepbAntibody',
            headerName: 'Has Donor Hepb Antibody',
            width: 110,
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    Has<br />Donor<br />HepB Antibody
                </SortableHeaderComponent>,
            cellRendererFramework: (props: ICellRendererParams) => props.value ? <Glyphicon glyph='ok' /> : null
        },
        {
            colId: 'hasDonorHepbAntigen',
            field: 'hasDonorHepbAntigen',
            headerName: 'Has Donor Hepb Antigen',
            width: 110,
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    Has<br />Donor <br />HepB Antigen
                </SortableHeaderComponent>,
            cellRendererFramework: (props: ICellRendererParams) => props.value ? <Glyphicon glyph='ok' /> : null
        },
        {
            colId: 'hasDonorRprVdrl',
            field: 'hasDonorRprVdrl',
            headerName: 'Has Donor Rpr Vdrl',
            width: 95,
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    Has<br />Donor <br />RPR Vdrl
                </SortableHeaderComponent>,
            cellRendererFramework: (props: ICellRendererParams) => props.value ? <Glyphicon glyph='ok' /> : null
        }
    ];

    const columnDefs = useMemo(() => reportColumns, []);
    const rowData = useMemo(() => props.report, [props.report]);

    return (
        <GridWrapper id='grid-wrapper' className='ag-theme-bootstrap' style={{ height: '77vh' }}>
            <AgGridReact
                defaultColDef={{
                    cellClass: 'center-list-cell',
                    headerClass: 'center-list-header',
                    sortable: true,
                    resizable: true
                }}
                columnDefs={columnDefs}
                rowData={rowData}
                headerHeight={62}
                onSortChanged={onSortChanged}
                noRowsOverlayComponentFramework={() => <div>No data for the selected date range...</div>}
                onGridReady={onGridReady}
                onFirstDataRendered={onFirstDataRendered}
                suppressCellSelection={true}
                enableCellTextSelection={true}
                enableRangeSelection={true}
            />
        </GridWrapper>
    );
}

export default DonorExportabilityReportGrid;